import React, { useRef, useState } from 'react';
import '../css/Home.css'
import SectionTwo from './SectionTwo';
import SectionThree from './SectionThree';
import SectionFour from './SectionFour';
import ContactSection from './ContactSection';
import Orb from '../components/Orb';
import BackgroundWrapper from './BackgroundWrapper';

const Home: React.FC = () => {
  const sectionFourRef = useRef<HTMLDivElement>(null);
  const contactSectionRef = useRef<HTMLDivElement>(null);
  const heroRef = useRef<HTMLDivElement>(null);
  const [showHeroBackground] = useState(true);


  const scrollToSectionFour = () => {
    sectionFourRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  const handleTalkToNimbli = () => {
    contactSectionRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <BackgroundWrapper>
      {/* Hero Section with Fixed Background */}
      <div className="space-hero" ref={heroRef}>
        {/* Orb background */}
        <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, zIndex: 10 }}>
          <Orb hoverIntensity={0.9} rotateOnHover={true} hue={0} forceHoverState={false} />
        </div>
        {/* Gradient Overlay */}
        <div className="gradient-overlay" style={{ opacity: showHeroBackground ? 1 : 0 }} />
        {/* Content */}
        <div className="content-container">
          <div className="content-wrapper">
            <div className="grid">
              {/* Text Content */}
              <div className="text-content">
                <h1 className="main-heading">Insurance Claims</h1>
                <h2 className="sub-heading">Without the Delay</h2>
                <div className='home-button-container'>
                    <button className="explore-button" onClick={scrollToSectionFour}>How it works</button>
                    <button className="explore-button" onClick={handleTalkToNimbli}>Talk to Crikey<sup>ai</sup></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SectionTwo/>

      <SectionThree/>
      
      <div ref={sectionFourRef}></div>

        <SectionFour/>

        <ContactSection />     

      <div ref={contactSectionRef}></div>
      
    </BackgroundWrapper>

  );
};

export default Home;